export const iso = {
    aa: "Afar",
    ab: "Abkhazian",
    af: "Africâner",
    ak: "Akan",
    am: "Amárico",
    an: "Aragonês",
    ar: "Árabe",
    as: "Assamês",
    av: "Avaric",
    ay: "Aymara",
    az: "Azerbaijano",
    ba: "Bashkir",
    be: "Bielorrusso",
    bg: "Búlgaro",
    bh: "Bihari",
    bi: "Bislamá",
    bm: "Bambara",
    bn: "Bengali",
    bo: "Tibetano",
    br: "Bretão",
    bs: "Bósnio",
    ca: "Catalão",
    ce: "Checheno",
    ch: "Chamorro",
    co: "Córsico",
    cr: "Cree",
    cs: "Tcheco",
    cu: "Eslovaco",
    cv: "Chuvash",
    cy: "Galês",
    da: "Dinamarquês",
    de: "Alemão",
    dv: "Dhivehi",
    dz: "Dzongkha",
    ee: "Ewe",
    el: "Grego",
    en: "Inglês",
    eo: "Esperanto",
    es: "Espanhol",
    et: "Estoniano",
    eu: "Basco",
    fa: "Persa",
    ff: "Fulah",
    fi: "Finlandês",
    fj: "Fijiano",
    fo: "Feroês",
    fr: "Francês",
    fy: "Frisian",
    ga: "Irlandês",
    gd: "Gaulês",
    gl: "Galego",
    gn: "Guarani",
    gu: "Gujarati",
    gv: "Manx",
    ha: "Hauçá",
    he: "Hebraico",
    hi: "Hindi",
    ho: "Hiri Motu",
    hr: "Croata",
    ht: "Crioulo haitiano",
    hu: "Húngaro",
    hy: "Armênio",
    hz: "Herero",
    ia: "Interlíngua",
    id: "Indonésio",
    ie: "Interlingue",
    ig: "Igbo",
    ii: "Sichuan Yi",
    ik: "Inupiaq",
    io: "Ido",
    is: "Islandês",
    it: "Italiano",
    iu: "Inuktitut",
    ja: "Japonês",
    jv: "Javanês",
    ka: "Georgiano",
    kg: "Kongo",
    ki: "Kikuyu",
    kj: "Kuanyama",
    kk: "Cazaque",
    kl: "Groenlandês",
    km: "Khmer",
    kn: "Kannada",
    ko: "Coreano",
    kr: "Kanuri",
    ks: "Caxemira",
    ku: "Curdo",
    kv: "Komi",
    kw: "Córnico",
    ky: "Kyrgyz",
    la: "Latim",
    lb: "Luxemburguês",
    lg: "Ganda",
    li: "Limburguês",
    ln: "Lingala",
    lo: "Lao",
    lt: "Lituano",
    lu: "Luba-Katanga",
    lv: "Letão",
    mg: "Malgaxe",
    mh: "Marshallese",
    mi: "Maori",
    mk: "Macedônio",
    ml: "Malaiala",
    mn: "Mongol",
    mr: "Marathi",
    ms: "Malaio",
    mt: "Maltês",
    my: "Birmanês",
    na: "Nauruano",
    nb: "Norueguês Bokmål",
    nd: "Ndebele do Norte",
    ne: "Nepali",
    ng: "Ndonga",
    nl: "Holandês",
    nn: "Norueguês Nynorsk",
    no: "Norueguês",
    nr: "Ndebele do Sul",
    nv: "Navajo",
    ny: "Chichewa",
    oc: "Occitan",
    oj: "Ojibwa",
    om: "Oromo",
    or: "Oriya",
    os: "Ossetic",
    pa: "Punjabi",
    pi: "Pali",
    pl: "Polonês",
    ps: "Pashto",
    pt: "Português",
    qu: "Quechua",
    rm: "Romanche",
    rn: "Kirundi",
    ro: "Romeno",
    ru: "Russo",
    rw: "Kinyarwanda",
    sa: "Sânscrito",
    sc: "Sardenha",
    sd: "Sindi",
    se: "Northern Sami",
    sg: "Sango",
    si: "Sinhala",
    sk: "Eslovaco",
    sl: "Esloveno",
    sm: "Samoano",
    sn: "Shona",
    so: "Somali",
    sq: "Albanês",
    sr: "Sérvio",
    ss: "Swati",
    st: "Sotho do Sul",
    su: "Sundanês",
    sv: "Sueco",
    sw: "Suaíli",
    ta: "Tâmil",
    te: "Telugu",
    tg: "Tajique",
    th: "Tailandês",
    ti: "Tigrínia",
    tk: "Turcomano",
    tl: "Tagalo",
    tn: "Tswana",
    to: "Tonga",
    tr: "Turco",
    ts: "Tsonga",
    tt: "Tatar",
    tw: "Twi",
    ty: "Taitiano",
    ug: "Uigur",
    uk: "Ucraniano",
    ur: "Urdu",
    uz: "Uzbeque",
    ve: "Venda",
    vi: "Vietnamita",
    vo: "Volapük",
    wa: "Valão",
    wo: "Wolof",
    xh: "Xhosa",
    yi: "Iídiche",
    yo: "Iorubá",
    za: "Zhuang",
    zh: "Chinês",
    zu: "Zulu",
  };